import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'

// routes config
import routes from '../routes'
import { LoadingSpinner } from 'src/consumer/components/Loaders'

const AppContent = () => {
  return (
    <Suspense fallback={<LoadingSpinner bgColor="#F5F5F599" dark />}>
      <Routes>
        {routes.map((route, idx) => {
          return route.element && <Route key={idx} {...route} element={<route.element />} />
        })}
      </Routes>
    </Suspense>
  )
}

export default React.memo(AppContent)
